import {Repository} from '@/repositories/Base/Repository'

class TypeInformationRepository extends Repository {
    endpoint = 'mapping/type/information'
    endpointCopy = 'mapping/type/information/copy'
    
    fetchAll(params) {
        return this.$axios.get(`${this.endpoint}/table`, {params})
    }
    
    postCopy(params) {
        return this.$axios.post(`${this.endpointCopy}`, params)
    }
}

export default new TypeInformationRepository()
